export default __webpack_public_path__ + "e11860f77657d3f34e74eeb7dead02c0.png";